import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import ModalMultimedia from '../../Partials/ModalMultimedia';

export default class EditarDocumentoExportacion extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            key: 0,
            tituloLongitud:0,
            descripcionLongitud:0,
            resource: {
                dexp_Titulo:"",
                dexp_Descripcion:"",
                dexp_Archivo:"",
                dexp_Cover:"",
                sect_Id:0,
                dexp_Orden:0,
                dexp_Activo:true
            },
            Validacion: {
                dexp_Titulo: {
                    Error: false,                    
                },
                dexp_Descripcion: {
                    Error: false,                    
                },
                dexp_Archivo: {
                    Error: false,                    
                },
                dexp_Cover: {
                    Error: false,                    
                },
                sect_Id: {
                    Error: false,                    
                },
                dexp_Orden: {
                    Error: false,                    
                }
            },
            sectores: [],
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:"",
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
      }

    getResponseMultimedia = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
    
            this.setState({resource:resource, fieldReturnMultimedia:""});
        }
    
        hideModalPageClass("divGestorArchivosMultimedia");
    }
    
    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }
    
    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/documento-exportacion";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
        
        const url = `${API_URL}DocumentoExportacionUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    sectores: data.result.sectores
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    componentWillMount(){
        
        var key = this.props.match.params.id;
        const url = `${API_URL}DocumentoExportacionUX/Seleccionar/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resource: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    
    }
    
    handleClickCancel(e) {

        if(e != undefined){
            e.preventDefault();
        }

        const {history: {push}} = this.props;    
        push('/documento-exportacion');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.dexp_Titulo == '') {              
            newState.Validacion.dexp_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.dexp_Descripcion == '') {  
            newState.Validacion.dexp_Descripcion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.dexp_Archivo == '') {  
            newState.Validacion.dexp_Archivo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.dexp_Cover == "") {  
            newState.Validacion.dexp_Cover = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.dexp_Orden == '') {  
            newState.Validacion.dexp_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}DocumentoExportacionUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'dexp_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.handleClickCancel();
                }, 1000);  

                setTimeout(() => { 
                    this.setState({added:false});
                }, 5000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'dexp_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'dexp_Descripcion'){
            descripcionLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });  
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Documento Exportación</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Documento Exportación
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='dexp_Titulo' value={this.state.resource.dexp_Titulo} maxLength={35} className={this.state.Validacion.dexp_Titulo.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={35}>{this.state.tituloLongitud}/35</span>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Descripción" name='dexp_Descripcion' value={this.state.resource.dexp_Descripcion} maxLength={250} className={this.state.Validacion.dexp_Descripcion.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={250}>{this.state.descripcionLongitud}/250</span>
                    </div>

                    <div className="txtFile x-1">
                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "dexp_Archivo")}/>
                        <input type="text" placeholder="Archivo" name='dexp_Archivo' value={this.state.resource.dexp_Archivo} className={this.state.Validacion.dexp_Archivo.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "dexp_Cover")}/>
                        <input type="text" placeholder="Cover" name='dexp_Cover' value={this.state.resource.dexp_Cover} className={this.state.Validacion.dexp_Cover.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Sector</option>
                            {
                                this.state.sectores.length > 0 ?
                                this.state.sectores.map((sector) => (
                                    <option value={sector.id} selected={(this.state.resource.sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>                        
                    </div>
                    
                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='dexp_Orden' value={this.state.resource.dexp_Orden} maxLength={2} className={this.state.Validacion.dexp_Orden.Error ? "error" : ""} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
